const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;
//const Backofficebff         : string = "/api";

export const HarmonyQuery: any = {
    IsStoreEmployee: Backofficebff + '/v1/harmony/isstoreemployee',
};
